export const ApiDef_MeasurementUnit = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map